import { Outlet, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { HomeIcon, NewspaperIcon, PencilSquareIcon, MoonIcon, SunIcon, ArrowLeftIcon, ArrowRightIcon, PowerIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

export default function DashboardLayout({ onLogout }) {
  
   const [dark, setDark] = useState(false); // ✅ now inside the component
    const [expanded, setExpanded] = useState(false);

   useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') setDark(true);
  }, []);

  useEffect(() => {
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);


  return (

    <div className={dark ? 'dark' : ''}>
      

    <div className="flex min-h-screen dark:bg-gray-800 dark:text-white transition-colors bg-gray-100">
       
        
         <aside className={`h-screen bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 shadow-lg transition-all duration-300 ease-in-out

 ${expanded ? 'w-64' : 'w-20'} flex flex-col justify-between`}>
             {/* Logo + Toggle */}
             <div className="p-4 flex items-center justify-center">
              <img src="/Logo.png" alt="Logo" className={`h-14 transition-all ${expanded ? 'block' : 'hidden'}`} />
               <button
                 onClick={() => setExpanded(!expanded)}
                 className="text-gray-600 dark:text-gray-300 hover:text-green-600 dark:hover:text-green-400"
               >
                 {expanded ? <ArrowLeftIcon className='h-5 w-5' />  : <ArrowRightIcon className='h-5 w-5' />}
               </button>
             </div>
       
             {/* Navigation */}
             <nav className="flex-1 p-4 space-y-4">
               <Link to="/dashboard" className={`flex items-center ${expanded ? 'space-x-2' : 'justify-center'}
 space-x-2 hover:text-green-600 dark:hover:text-green-400`}>
                 <HomeIcon className="h-5 w-5" />
                 {expanded && <span>Dashboard</span>}
               </Link>
               <Link to="/dashboard/news" className={`flex items-center ${expanded ? 'space-x-2' : 'justify-center'}
 space-x-2 hover:text-green-600 dark:hover:text-green-400`} >
                  <NewspaperIcon className="h-5 w-5" />
                 {expanded && <span>News Updates</span>}
               </Link>
               <Link to="/dashboard/blog" className={`flex items-center ${expanded ? 'space-x-2' : 'justify-center'}
 space-x-2 hover:text-green-600 dark:hover:text-green-400`}>
              <PencilSquareIcon className="h-5 w-5" />
                 {expanded && <span>Blog Posts</span>}
               </Link>
               <Link to="/dashboard/help" className={`flex items-center ${expanded ? 'space-x-2' : 'justify-center'} space-x-2 hover:text-green-600 dark:hover:text-green-400`}>
               <QuestionMarkCircleIcon className="h-5 w-5" />
               {expanded && <span>Documentation</span>}
               </Link>
             </nav>
       
             {/* Controls */}
           <div className={`p-4 ${expanded ? 'flex space-x-2' : 'flex flex-col items-center space-y-4'}`}>
  {/* Dark Mode Button */}
  <button
    onClick={() => setDark(!dark)}
    className={`flex items-center justify-center dark:text-white text-black rounded  active:scale-95 transition-colors duration-300
 transition-transform
 ${
      expanded ? 'flex-1 px-4 py-2 space-x-2' : 'w-10 h-10'
    }`}
  >
    {dark ? <SunIcon className="h-5 w-5" /> : <MoonIcon className="h-5 w-5" />}
    {expanded && <span>{dark ? 'Light Mode' : 'Dark Mode'}</span>}
  </button>

  {/* Logout Button */}
  <button
    onClick={onLogout}
    className={`flex items-center justify-center dark:text-white text-black rounded active:scale-95 transition-transform
 ${
      expanded ? 'flex-1 px-4 py-2 space-x-2' : 'w-10 h-10'
    }`}
  >
    <PowerIcon className="h-5 w-5" />
    {expanded && <span>Logout</span>}
  </button>
</div>






           </aside>
        
      

      <main className="flex-1 p-4 sm:p-10 relative dark:bg-gray-900 animate-fadeIn">
        <Outlet />
      </main>
    </div>
    </div>
  );
}